/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SalesContract56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M12 14a8 8 0 110 16 8 8 0 010-16zM36 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path fill={vars.white} d="M15 8h25a3 3 0 013 3v33a3 3 0 01-3 3H12V11a3 3 0 013-3z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M49.5 51a.5.5 0 010 1h-13a.5.5 0 010-1h13zM40 6a4.999 4.999 0 014.995 4.783L45 11l.001 19.57a3.792 3.792 0 011.792 3.223l-.002.136-.007.135-.71 9.936H49a3 3 0 012.995 2.824L52 47v1a2.001 2.001 0 01-1.85 1.995L50 50H36a2.001 2.001 0 01-1.995-1.85L34 48H9a4 4 0 01-3.995-3.8L5 44v-6h6V11a4.999 4.999 0 014.783-4.995L16 6h24zm9 40h-5a4.99 4.99 0 01-3.783 1.995L40 48h10v-1a1 1 0 00-1-1zM40 8H16a3 3 0 00-2.995 2.824L13 11v33c0 .729-.195 1.413-.536 2.001h21.707a3.002 3.002 0 012.653-1.996L37 44h2.925l-.709-9.936a3.795 3.795 0 013.32-4.036l.194-.018c.09-.007.18-.01.27-.01V11a3 3 0 00-2.824-2.995L40 8zM11 40H7v4a2 2 0 001.697 1.977l.154.018L9 46a2.001 2.001 0 001.995-1.85L11 44v-4zm32.001-8H43l-.128.005a1.793 1.793 0 00-1.665 1.769l.004.147.72 10.079h.898c.092-.26.15-.536.166-.824L43 43l.001-11zM34.5 39a.5.5 0 010 1h-13a.5.5 0 010-1h13zm0-3a.5.5 0 010 1h-13a.5.5 0 010-1h13zm0-3a.5.5 0 010 1h-13a.5.5 0 010-1h13zm-5-18a.5.5 0 01.5.5V17h2a1 1 0 01.117 1.993L32 19h-2v2a3 3 0 01.176 5.995L30 27v1.5a.5.5 0 01-1 0V27h-1v1.5a.5.5 0 01-1 0V27h-3a1 1 0 01-.117-1.993L24 25h3v-2h-1a3 3 0 01-.176-5.995L26 17h1v-1.5a.5.5 0 011 0V17h1v-1.5a.5.5 0 01.5-.5zm-.5 8h-1v2h1v-2zm1 0v2a1 1 0 00.117-1.993L30 23zm-1-4h-1v2h1v-2zm-2 0h-1a1 1 0 00-.117 1.993L26 21h1v-2z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M7 40h4v4a2 2 0 01-2 2l-.15-.005A2.001 2.001 0 017 44v-4zm37.793-6.207l-.004.128L44.068 44h-2.137l-.72-10.079a1.793 1.793 0 011.661-1.916L43 32c.99 0 1.793.803 1.793 1.793zM37 46h12a1 1 0 011 1v1H36v-1a1 1 0 011-1z"
            />
        </g>
    </AccessibleSVG>
);

export default SalesContract56;
